//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { TransactionType } from './Enums';

export abstract class TransactionInputItem extends ItemBase {
    TransactionType: TransactionType = TransactionType.Payment;
    FamilyID: string | null = null;
    StudentID: string | null = null;
    Amount: number = 0;
    Description: string | null = null;
    Timestamp: string = "1970-01-01T00:00:00";

    static readonly ClassName: string = "TransactionInputItem";
}
